@use '@design/design-tokens/typography/typography' as *;

.flexRow {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
}

.flexColumn {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.title {
  @include typography-v2-body-sm;
}

.subtitle {
  @include typography-v2-body-xs;
  color: var(--text-soft);
}
